<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="cn" id="_idParaDest-5"><a id="_idTextAnchor004"></a><a href="#/text/nav#r_idParaDest-5"><span class="right_1" epub:type="pagebreak" id="page_3" title="3">BEFORE</span></a></h2>
<p class="noindent"><span class="dropcap">A</span>mrita walked by his side and he by hers, two halves of a whole. When she was with him, a feeling rose up inside her. It wasn’t until much later in life that she recognized it as hope.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062674623_Chapter_1.vue?c4bdd0b6